import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { StorageService } from '../services/storage.service';
import { AuthConstants } from '../config/auth-constants';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { errorObject } from 'rxjs/internal-compatibility';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  token: string;
  hrm_token: string
  constructor(
    private router: Router,
    private http: HttpClient,
    private storageService: StorageService,
  ) {
    this.storageService.get(AuthConstants.TOKEN).then(res => {
      this.token = res;
    });
    this.storageService.get(AuthConstants.HRM_TOKEN).then(res => {
      this.hrm_token = res;
    });

  }

  refreshToken() {
    this.storageService.get(AuthConstants.TOKEN).then(res => {
      this.token = res;
    });
    this.storageService.get(AuthConstants.HRM_TOKEN).then(res => {
      this.hrm_token = res;
    });
  }

  post_authenticate(serviceName: string, data: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return this.http.post(url, JSON.stringify(data), options);
  }

  post(serviceName: string, data: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': `${this.token}`
    });

    const options = { headers: headers };
    return this.http.post<any>(url, JSON.stringify(data), options);
  }

  postAttachFile(serviceName: string, data: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      'x-access-token': `${this.token}`,
    });
    const options = { headers: headers };
    return this.http.post<any>(url, data, options);
  }

  postToHrm(serviceName: string, data: any, permission: any, action: any) {
    action.code = permission;
    const url = environment.apiUrlHrm + serviceName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${this.hrm_token}`,
      'x-access-permission': `${JSON.stringify(action)}`
    });
    const options = { headers: headers };
    return this.http.post<any>(url, JSON.stringify(data), options);
  }
  downloadFileHRM(serviceName: string, data: any, permission: any, action: any): Observable<any> {
    action.code = permission;
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-permission': `${JSON.stringify(action)}`,
      'Authorization': `${this.token}`
    });
    const options = { headers: headers };
    return this.http.post<any>(url, data, { ...options, responseType: 'blob' as 'json' })
      .pipe(
        map(this.extractData),
        catchError(this.handleErrorObservable)
      );
  }
  private extractData(res: any) {
    if (res.type == 'application/json') {
      return {
        errors: {
          message: 'common.message.noDataToExport',
          data: null,
        }
      }
    } else {
      return res;
    }
  }
  private handleErrorObservable(error: any) {
    console.log('handleErrorObservable', error.message || error);
    return throwError(error);
  }

  get(serviceName: string, permission: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': `${this.token}`,
      'x-access-permission': `${JSON.stringify(permission)}`
    });
    const options = { headers: headers };
    return this.http.get(url, options);
  }

  downloadAttachFile(serviceName: string, data: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': `${this.token}`
    });
    const options = { headers: headers };
    return this.http.post<any>(url, data, { ...options, responseType: 'blob' as 'json' });
  }

  postPermission(serviceName: string, data: any, permission: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': `${this.token}`,
      'x-access-permission': `${JSON.stringify(permission)}`
    });
    const options = { headers: headers };
    return this.http.post<any>(url, JSON.stringify(data), options);
  }
  postPermissionAttachFile(serviceName: string, data: any, permission: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      // 'Content-Type': 'multipart/form-data',
      'x-access-token': `${this.token}`,
      'x-access-permission': `${JSON.stringify(permission)}`
    });
    const options = { headers: headers };
    return this.http.post<any>(url, data, options);
  }
  downloadAttachFilePermission(serviceName: string, data: any, permission: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-permission': `${JSON.stringify(permission)}`,
      'x-access-token': `${this.token}`
    });
    const options = { headers: headers };
    return this.http.post<any>(url, data, { ...options, responseType: 'blob' as 'json', observe: 'response' }).pipe(
      map(res => {
        let error = res.headers.get('error-object');
        if (error) {
          return JSON.parse(decodeURI(error))
        }
        let disposition = res.headers.get('content-disposition');
        let fileName;
        if (disposition) {
          fileName = disposition.slice(disposition.indexOf('filename=') + 9)
        }
        let name = res.headers.get('content-type');
        let blob = res.body;
        let result = blob.slice(0, blob.size,  fileName ?? name);
        return result;
      })
    );
  }
  downloadAttachFilePermissionƯithAny(serviceName: string, data: any, permission: any) {
    const url = environment.apiUrl + serviceName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-permission': `${JSON.stringify(permission)}`,
      'x-access-token': `${this.token}`
    });
    const options = { headers: headers };
    return this.http.post<any>(url, data, options);
  }
}
